module.exports = __webpack_public_path__ + "media/images/lb/623-93a5d57df88859d4922a27db0f76669d.svg";